import React, { Component } from "react";
import { TextField, MenuItem, Button, OutlinedInput } from "@material-ui/core";
import SearchIcon from "../assets/search.png";
import NextArrow from "../assets/upAerrow.png";
import { fetchMethod } from "../../FetchMethod";

import "./campaign.css";
import {
  ContactSearch,
  CampaignSearch,
  Company,
  CampaignData
} from "./SearchCampaignQuery";

import Autocomplete from "@material-ui/lab/Autocomplete";
//import store from "../../Redux/Store";

class SearchCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerlist: [],
      search: "",
      
      CampaignManagerList: [],
      searchFlag: false,
      clickToSearch: false,
      Company: [],
      
      status: "Live",
      flag: false,
      cust: [],
      options2: [],
      ManagerId: undefined,
      ManagerId1: "All",
      CustomerId: "All",
      company: "All",
      value: "All",
      limit: this.props.limit,
      offset: this.props.offset
    };
  }
  componentDidMount() {
    this.setState({
      options2: [
        { id: "ALL", name: "All" },
        { id: "PAUSED", name: "Paused" },
        { id: "COMPLETED", name: "Completed" },
        { id: "NOTSTARTED", name: "Notstarted" }
      ]
    });
    this.fetchdata();
    this.fetchmanager();
    this.fetchManagerData();
  }

  fetchdata = () => {
    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id")
              
            }
          }
        : localStorage.getItem("role") === "CAMPAIGNMANAGER"
        ? {
            where: {
              campaignmanagerid: localStorage.getItem("id")
              
            }
          }
        : localStorage.getItem("role") === "CUSTOMER"
        ? {
            where: {
              customerid: localStorage.getItem("customer")
             
            }
          }
        : {
            where: {
              
            }
          };

    fetchMethod(ContactSearch, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        responseAsJson !== undefined
          ? this.setState(
              {
                Company: responseAsJson.data.allCampaigns.Campaigns.map(id => {
                  return id.customerIbfk1rel.Customers !== undefined
                    ? id.customerIbfk1rel.Customers.length > 0
                      ? id.customerIbfk1rel.Customers[0]
                      : ""
                    : "";
                })
              },
              () => this.SearchCompany()
            )
          : this.setState({ loading: true });
      })
      .catch(e => {
        this.setState({ loading: true });
      });
  };
  SearchCompany = () => {
    const filter = {
      where: {
     
        and: [
          {
            or: this.state.Company.map(id => {
              return { id: id.id };
            })
          }
        ],
        order: "company asc"
      }
    };
    fetchMethod(Company, filter)
      .then(res => res.json())
      .then(res => {
        res.data.allCustomers !== undefined && res.data.allCustomers !== null
          ? this.setState({ customerlist: res.data.allCustomers.Customers })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  clearFilters = () => {
    this.setState(
      {
        options2: [
          { id: "ALL", name: "All" },
          { id: "PAUSED", name: "Paused" },
          { id: "COMPLETED", name: "Completed" },
          { id: "NOTSTARTED", name: "Notstarted" }
        ],
        company: "All",
        CustomerId: "",
        ManagerId: "",
        ManagerId1: "All",
        search: "",
        status: "LIVE",
        searchFlag: false,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.props.ManagerId(this.state.ManagerId);
        this.props.CustomerId(this.state.CustomerId);
        this.props.Status(this.state.status);
        this.fetchmanager();
        this.props.onHandleSearchChange(this.state.search);
      }
    );
  };
  fetchmanager = () => {
    const filter =
      localStorage.getItem("role") === "CUSTOMER"
        ? {
            where: {
              id: localStorage.getItem("customer")
            }
          }
        : this.state.CustomerId !== "All"
        ? {
            where: {
              id: this.state.CustomerId
            }
          }
        : {};

    fetchMethod(CampaignSearch, filter)
      .then(res => res.json())
      .then(res => {
        res.data.allCustomers !== undefined && res.data.allCustomers !== null
          ? this.setState(
              {
                cust:
                  res.data.allCustomers.Customers[0] !== undefined
                    ? res.data.allCustomers.Customers[0].campaignfk.Campaigns.map(
                        id => {
                          return id.Manager.Usersdata;
                        }
                      )
                    : ""
              },
              () => {
                this.fetchManagerData();
              }
            )
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };
  fetchManagerData = () => {
    const filter =
      localStorage.getItem("role") === "CUSTOMER"
        ? {
            where: {
              and: [
                {
                  or:
                    this.state.cust.length > 0
                      ? this.state.cust.map(id => {
                          return { id: id[0] !== undefined ? id[0].id : "" };
                        })
                      : [{ id: "" }]
                }
              ],
              order: "firstName asc"
            }
          }
        : localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
           
              role: "CAMPAIGNMANAGER",
              createdby: localStorage.getItem("id"),
              order: "firstName asc"
            }
          }
        : localStorage.getItem("role") === "SADMIN"
        ? {
            where: {
          
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          }
        : this.state.cust.length > 0
        ? {
            where: {
              and: [
                {
                  or:
                    this.state.cust.length > 0
                      ? this.state.cust.map(id => {
                          return { id: id[0] !== undefined ? id[0].id : "" };
                        })
                      : [{ id: "" }]
                }
              ],
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          };

    fetchMethod(CampaignData, filter)
      .then(res => res.json())
      .then(res => {
        res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
          ? this.setState({
              CampaignManagerList:
                localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                  ? res.data.allUsersdata.Usersdata
                  : ""
            })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  selectListChange = (event, v) => {
    if (v !== undefined && v !== null) {
      this.setState(
        {
          company: "",
          CustomerId: "",

          ManagerId1: "All",
          ManagerId: undefined
        },
        () => {
          this.setState(
            {
              company: v.company,
              CustomerId: v.id,

              ManagerId: "All",
              CampaignManagerList: [],
              flag: true,
              searchFlag: true
            },
            () => {
              this.props.ManagerId(this.state.ManagerId);
              this.props.CustomerId(this.state.CustomerId);
              this.fetchmanager();
              this.onSearchClick();
            }
          );
        }
      );
    } else {
      this.setState({
        company: "All",
        ManagerId: undefined,
        ManagerId1: "All",
        loading: true
      });
    }
  };

  selectAssignToChange = (event, v) => {
    if (
      v !== undefined &&
      v !== null
      
    )
      this.setState(
        {
          ManagerId: "",
          ManagerId1: ""
        },
        () => {
          let FirstName =
            v.firstName !== undefined && v.firstName !== null
              ? v.firstName
              : "";
          let LastName =
            v.lastName !== undefined && v.lastName !== null ? v.lastName : "";
          this.setState(
            {
              ManagerId: v.id,
              ManagerId1: FirstName + " " + LastName,
              searchFlag: true
            },
            () => {
              this.fetchdata();
              this.props.ManagerId(this.state.ManagerId);
              this.props.CustomerId(this.state.CustomerId);
              this.onSearchClick();
            }
          );
        }
      );
    else {
      this.setState({ CampaignManagerList: this.state.CampaignManagerList });
    }
  };

  onStatusChange = event => {
    if (event.target.outerText === "Live") {
      this.setState({
        options2: [
          { id: "ALL", name: "All" },
          { id: "PAUSED", name: "Paused" },
          { id: "COMPLETED", name: "Completed" },
          { id: "NOTSTARTED", name: "Notstarted" }
        ]
      });
    }
    if (event.target.outerText === "All") {
      this.setState({
        options2: [
          { id: "LIVE", name: "Live" },
          { id: "PAUSED", name: "Paused" },
          { id: "COMPLETED", name: "Completed" },
          { id: "NOTSTARTED", name: "Notstarted" }
        ]
      });
    }
    if (event.target.outerText === "Paused") {
      this.setState({
        options2: [
          { id: "ALL", name: "All" },
          { id: "LIVE", name: "Live" },
          { id: "COMPLETED", name: "Completed" },
          { id: "NOTSTARTED", name: "Notstarted" }
        ]
      });
    }
    if (event.target.outerText === "Completed") {
      this.setState({
        options2: [
          { id: "ALL", name: "All" },
          { id: "LIVE", name: "Live" },
          { id: "PAUSED", name: "Paused" },
          { id: "NOTSTARTED", name: "Notstarted" }
        ]
      });
    }
    if (event.target.outerText === "Notstarted") {
      this.setState({
        options2: [
          { id: "ALL", name: "All" },
          { id: "LIVE", name: "Live" },
          { id: "PAUSED", name: "Paused" },
          { id: "COMPLETED", name: "Completed" }
        ]
      });
    }
    this.setState(
      {
       
        status: event.target.outerText,
        searchFlag: true
      },
      () => {
        this.props.Status(this.state.status.toUpperCase());
        this.onSearchClick();
      }
    );
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;

  handleChange = event => {
    this.setState({ search: event.target.value }, () => {
      if (this.state.search !== "") {
        this.setState({
          searchFlag: true
        });
      } else {
        this.setState({
          searchFlag: false
        });
      }
      this.debounceTimer = this.debounce(
        this.debounceTimer,
        () => {
          this.onSearchClick();
        },
        300
      );
      this.props.onHandleSearchChange(this.state.search);
    });
  };

  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.props.onhandleSearch(this.state.searchFlag);
        this.props.onHandleClickSearch(this.state.clickToSearch);
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.props.onhandleSearch(this.state.searchFlag);
        this.props.onHandleClickSearch(this.state.clickToSearch);
      });
    }
  };
  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };

  render() {
    return (
      <div className="allFiltersCompaigns">
        <div className="selectCustomer">
          <label className="custom-label">Customer</label>
          <Autocomplete
            id="country-select-demo"
            
            blurOnSelect={true}
            onChange={(event, value) => this.selectListChange(event, value)}
            options={this.state.customerlist ? this.state.customerlist : []}
          
            value={
              localStorage.getItem("role") === "CUSTOMER"
                ? localStorage.getItem("companyName")
                : 

                  this.state.company
            }
           
            disabled={
              localStorage.getItem("role") === "CUSTOMER" ? true : false
            }
            renderOption={option => (
              <MenuItem value={option.id}>{option.company}</MenuItem>
            )}
            renderInput={params => (
              <TextField
                id="outlined-select-currency"
                {...params}
                variant="outlined"
                value={null}
                InputProps={{
                  ...params.InputProps,
              

                  endAdornment: (
                    <img
                      src={NextArrow}
                      style={{
                        width: "17px",
                        cursor: "pointer"
                      }}
                    />
                  )
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{
                  ...params.inputProps
               
                }}
              />
            )}
          />
        </div>

        <div className="selectAssign">
          <label className="custom-label">Campaign Manager</label>
          <Autocomplete
            id="country-demo"
            value={
              localStorage.getItem("role") === "CAMPAIGNMANAGER"
                ? localStorage.getItem("name")
                : 
                  this.state.ManagerId1
            }
            disabled={
              localStorage.getItem("role") === "CAMPAIGNMANAGER" ? true : false
            }
            blurOnSelect={true}
            onChange={(event, value) => this.selectAssignToChange(event, value)}
            options={
              this.state.CampaignManagerList
                ? this.state.CampaignManagerList
                : []
            }
            renderOption={option => (
              <MenuItem value={option.id}>
                {" "}
                {option.firstName + " " + option.lastName}
              </MenuItem>
            )}
            renderInput={params => (
              <TextField
                id="outlined-select-currency"
                {...params}
                variant="outlined"
                value={null}
                InputProps={{
                  ...params.InputProps,
                

                  endAdornment: (
                    <img
                      src={NextArrow}
                      style={{
                        width: "17px",
                     cursor: "pointer"
                      }}
                    />
                  )
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{
                  ...params.inputProps
               
                }}
              />
            )}
          />
        </div>
     
        <div className="selectAssign">
          <label className="custom-label">Campaign Status</label>
          <Autocomplete
            id="country-demo"
            value={this.state.status}
            blurOnSelect={true}
            onChange={this.onStatusChange}
            options={this.state.status ? this.state.options2 : []}
            renderOption={option => (
              <MenuItem value={option.id}> {option.name}</MenuItem>
            )}
            renderInput={params => (
              <TextField
                id="outlined-select-currency"
                {...params}
                variant="outlined"
                value={null}
                InputProps={{
                  ...params.InputProps,

                  endAdornment: (
                    <img
                      src={NextArrow}
                      style={{
                        width: "17px",
                        cursor: "pointer"
                      }}
                    />
                  )
                }}
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{
                  ...params.inputProps
                }}
              />
            )}
          />
        </div>

        <div className="searchContact">
          <label className="custom-label">Search</label>
          <TextField
            id="outlined-search"
           
            InputLabelProps={{
              shrink: true
            }}
            placeholder="Search campaign here..."
            type="text"
            onChange={this.handleChange}
            value={this.state.search}
            onKeyDown={this.onSearchKeyDown}
            margin="normal"
            variant="outlined"
            InputProps={{
              endAdornment: (
                <img
                  src={SearchIcon}
                  onClick={this.onSearchClick}
                  style={{ width: "15px", cursor: "pointer" }}
                />
              )
            }}
          />
        </div>

        <div className="campaignClearButton">
          <Button className="button" onClick={this.clearFilters}>
            <span style={{ textTransform: "capitalize" }}> Reset All</span>
          </Button>
        </div>
      </div>
    );
  }
}

export default SearchCampaign;
